import React from 'react';
import styles from './TemplateEditBanner.scss';
import { Text } from '@wix/wix-base-ui';
// TODO: import { translate } from '#packages/i18n';
export default function TemplateEditBanner() {
  return (
    <div className={styles.templateEditBanner}>
      <Text
        size="small"
        weight="normal"
        className={styles.templateEditBannerText}
      >
        TOPBAR_Templates_Edit_Custom_Template_Status
      </Text>
    </div>
  );
}
